<template>
    <div>
        <el-tabs type="border-card" v-model="activeName">
            <el-tab-pane name='first' label="服务器" id="users_tab">
                <el-col :span="24" class="toolbar" align="left">
                    <el-form :inline="true" :model="formInline" class="demo-form-inline">
                        <el-form-item>
                            <el-input v-model="formInline.Server" placeholder="区域名称"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" style="width: 120px" icon="el-icon-search" @click.native.prevent="handleSearch">查找</el-button>
                        </el-form-item>
                        <el-form-item>
                            <el-button icon="el-icon-edit" style="width: 120px" @click.native.prevent="handleAdd">添加</el-button>
                        </el-form-item>
                    </el-form>
                </el-col>
                <el-table :data="currentTableData" stripe style="width: 100%;" @row-click="handleModify">
                    <div v-for="(item,index) in tabInformation" :key="index">
                        <el-table-column :prop="item.prop" :label="item.label" :width="item.width" sortable></el-table-column>
                    </div>
                    <el-table-column prop="Action" label="操作">
                        <template slot-scope="scope">
                            <el-button size="mini" type="primary" @click="handleModify(scope.row)" v-show="seen()" icon="el-icon-edit"></el-button>
                            <el-button size="mini" type="danger" @click="handleDelete(scope.row)" v-show="seen()" icon="el-icon-delete"></el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <!--分页-->
                <el-col :span="24" class="toolbar">
                    <el-pagination
                            :current-page="pageIndex" :page-sizes="pageSizes" :page-size="pageSize"
                            layout="total, prev, pager, next"
                            :total="totaltotal"
                            v-on:current-change="pageIndexChange"
                            v-on:size-change="sizeChange"
                            style="margin-top:5px">
                    </el-pagination>
                </el-col>
                <el-dialog :title="formTitle" :visible.sync="formVisible" class='modify' width='450px'>
                    <el-form :model="serverForm" ref="serverForm" :rules="serverRules">
                        <el-form-item label="区域" :label-width="formLabelWidth" prop="domain">
                            <el-input v-model="serverForm.domain" style="width: 300px" :disabled="editType!==0"></el-input>
                        </el-form-item>
                        <el-form-item label="AlexaServer" :label-width="formLabelWidth" prop="alexa_server">
                            <el-input v-model="serverForm.alexa_server"  style="width: 300px"></el-input>
                        </el-form-item>
                        <el-form-item label="DomainServer" :label-width="formLabelWidth" prop="domain_server">
                            <el-input v-model="serverForm.domain_server"  style="width: 300px"></el-input>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button style="width: 80px" @click="formVisible = false">取 消</el-button>
                        <el-button style="width: 80px" type="primary" @click="submitForm('userForm')">提 交</el-button>
                    </div>
                </el-dialog>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>

    import { mapState } from 'vuex'
    import { Config } from '@/config/config'
    import { addServer, modifyServer, deleteServer } from '@/api/server'
    import Notify from '../../api/notifyMsg'

    export default {
        name: 'Server',
        computed: mapState({
            user: state => state.user
        }),
        components: {},
        data() {
            return {
                formInline: {
                    Server: ''
                },
                tabInformation: [
                    {
                        prop: 'alexa_server',
                        label: 'AlexaServer',
                        width: '400'
                    },
                    {
                        prop: 'domain',
                        label: '区域',
                        width: '100'
                    },
                    {
                        prop: 'domain_server',
                        label: 'DomainServer',
                        width: '300'
                    },
                ],

                currentTableData: [],
                pageIndex: 1,
                pageSizes: [10, 20, 30, 40, 50],
                pageSize: 10,
                totaltotal: 0,
                editType : 0,//0 add; 1 modify
                formVisible: false,
                serverForm: {
                    domain: '',
                    alexa_server: '',
                    domain_server: ''
                },
                serverRules: {
                    domain: [{
                        required: true, message: '请输入Domain',trigger: 'blur'
                    }],
                    alexa_server: [{
                        required: true, message: '请输入Alexa Server', trigger: 'blur'
                    }],
                    domain_server: [{
                        required: true, message: '请输入Domain Server', trigger: 'blur'
                    }],
                },
                formTitle: '服务器修改',
                formLabelWidth: '100px',
                activeName: 'first',
                input: ''
            }
        },
        mounted() {
            this.getServerData();
        },
        methods: {
            seen() {
                if(this.user.Role !== "admin") {
                    return false;
                } else {
                    return true;
                }
            },
            getServerData() {
                var _this = this
                _this.currentTableData = [];
                var offset = (_this.pageIndex - 1) * _this.pageSize;
                var keyword = _this.formInline.Server;
                console.log("getData keyowrd:", keyword)
                fetch(Config.url + "/api/v1/console/server?offset=" + offset + "&limit=" + _this.pageSize + "&keyword=" + keyword + "&token=" + _this.user.token)
                    .then(response => response.json())
                    .then(json => {
                        //test data start
                        /*var jsonstr = '{"area_configs":[{"domain":"EU", "alexa_server":"avs-alexa-eu.amazon.com", "domain_server":"ai.tclking.com"},' +
                            '{"domain":"EU", "alexa_server":"avs-alexa-eu.amazon.com", "domain_server":"ai.tclking.com"},' +
                            '{"domain":"AS", "alexa_server":"avs-alexa-fe.amazon.com", "domain_server":"sgpai.tclking.com"},' +
                            '{"domain":"NA", "alexa_server":"avs-alexa-na.amazon.com", "domain_server":"ai.tclking.com"}]}';
                        var json = JSON.parse(jsonstr);*/
                        //test data end
                        console.log(json);
                        if (json.Error_code === 1000) {
                            var i;
                            //var s = new Set();
                            for (i = 0; i < json.servers.length; i ++) {
                                var domain = json.servers[i].domain;

                                var alexa_server = json.servers[i].alexa_server;
                                var domain_server = json.servers[i].domain_server;

                                _this.$set(_this.currentTableData, i, new _this.showServer(domain, alexa_server, domain_server));
                            }

                            _this.totaltotal = json.count;
                        } else {
                            console.log("error!")
                            Notify.errMsgNotify(json.Error_code, this)
                            return
                        }
                    })
                console.log(_this.currentTableData)
            },
            /*addServer(domain, alexa_server, domain_server) {

            },*/

            showServer(domain, alexa_server, domain_server) {
                this.domain = domain;
                this.alexa_server = alexa_server;
                this.domain_server = domain_server;
            },
            handleSearch() {
                var _this = this;
                _this.getServerData();
            },
            handleModify(row, event, column) {
                var _this = this;
                if(column !== undefined && column.property === "Action") {
                    return;
                }
                if (!_this.seen()) {
                    _this.$message({
                        type: 'fail',
                        message: '没有操作权限！'
                    });
                    return
                }

                console.log("handleModify ", row)
                _this.formTitle = '修改服务器';
                _this.formVisible = true;

                _this.editType = 1;

                _this.serverForm.domain = row.domain;
                _this.serverForm.alexa_server = row.alexa_server;
                _this.serverForm.domain_server = row.domain_server;
            },
            handleDelete(row){
                var _this = this;
                var _domain = row.domain;
                var query = "domain=" + _domain + "&token=" + _this.user.token;
                console.log("handleDelete query:", query)
                deleteServer(query)
                    .then(response => {
                        console.log(response)
                        if (response.data.Error_code === 1000) {
                            _this.$message({
                                type: 'success',
                                message: '删除成功！'
                            });
                            _this.currentTableData = [];
                            _this.getServerData();
                        } else {
                            /*_this.$message({
                                type: 'fail',
                                message: '删除失败，请重试。'
                            })*/
                            Notify.errMsgNotify(response.data.Error_code, this)
                        }
                    })
            },
            handleAdd() {
                var _this = this;
                if (!_this.seen()) {
                    _this.$message({
                        type: 'fail',
                        message: '没有操作权限！'
                    });
                    return
                }

                _this.formTitle = '添加服务器';
                _this.formVisible = true;
                _this.editType = 0;

                _this.serverForm.domain = '';
                _this.serverForm.alexa_server = '';
                _this.serverForm.domain_server = '';
            },
            submitForm() {
                var _this = this;
                var _domain = _this.serverForm.domain
                var _alexa_server = _this.serverForm.alexa_server;
                var _domain_server = _this.serverForm.domain_server;
                _this.$refs.serverForm.validate((valid) => {
                    console.log("valid")
                    if (valid) {
                        _this.$confirm('确认提交吗？', '提示', {}).then(() => {
                            _this.editLoading = true;
                            _this.btnEditText = '提交中';

                            if (_this.editType === 0) {
                                var i = 0;
                                for (; i<_this.currentTableData.length; i++) {
                                    if (_this.currentTableData[i].domain.toLowerCase() === _domain.toLowerCase()) {
                                        _this.$message({
                                            type: 'fail',
                                            message: '该区域的server已经存在！'
                                        });
                                        return
                                    }
                                }

                                addServer(_domain, _alexa_server, _domain_server, _this.user.token)
                                    .then(response => {
                                        console.log(response)
                                        if (response.data.Error_code === 1000) {
                                            _this.$message({
                                                type: 'success',
                                                message: '添加成功！'
                                            });
                                            _this.getServerData();
                                        } else {
                                            /*_this.$message({
                                             type: 'fail',
                                             message: '添加失败，请重试。'
                                             })*/
                                            Notify.errMsgNotify(response.data.Error_code, this)
                                        }
                                    })
                            } else if (_this.editType === 1) {
                                modifyServer(_domain, _alexa_server, _domain_server, _this.user.token)
                                    .then(response => {
                                        console.log(response)
                                        if (response.data.Error_code === 1000) {
                                            _this.$message({
                                                type: 'success',
                                                message: '修改成功！'
                                            });
                                            _this.getServerData();
                                        } else {
                                            /*_this.$message({
                                             type: 'fail',
                                             message: '添加失败，请重试。'
                                             })*/
                                            Notify.errMsgNotify(response.data.Error_code, this)
                                        }
                                    })
                            }
                            setTimeout(function() {
                                _this.editLoading = false;
                                //NProgress.done();
                                _this.btnEditText = '提 交';
                                _this.formVisible = false;
                            }, 1000);
                        });
                    }
                });
                //_this.formVisible = false;
            },
            pageIndexChange: function(pageIndex) {
                var _this = this
                _this.pageIndex = pageIndex
                _this.getServerData()
            },
            sizeChange: function(pageSize) {
                var _this = this
                _this.pageSize = pageSize
                _this.getServerData()
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/server/Server.vue